module.exports = __webpack_public_path__ + "static/media/Monday_Step0_Titlecard.e207d486.webp";